module.exports = __webpack_public_path__ + "da201dafde23912d9c0dabf1a8bb2673.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/5.png
// module id = 287
// module chunks = 0